document.addEventListener("DOMContentLoaded", function () {
    // Paus/play-knapp för bakgrundsvideon i hero
    const heroVideo = document.querySelector(".hero #video");
    const toggleBtn = document.querySelector("#hero-video-toggle");

    if (heroVideo && toggleBtn) {
        const pauseIcon = toggleBtn.querySelector(".icon-pause");
        const playIcon = toggleBtn.querySelector(".icon-play-svg");

        function updateToggle() {
            const paused = heroVideo.paused;
            pauseIcon.classList.toggle("hidden", paused);
            playIcon.classList.toggle("hidden", !paused);
            toggleBtn.setAttribute(
                "aria-label",
                paused ? toggleBtn.dataset.labelPlay : toggleBtn.dataset.labelPause
            );
        }

        toggleBtn.addEventListener("click", function () {
            if (heroVideo.paused) {
                heroVideo.play();
            } else {
                heroVideo.pause();
            }
        });

        heroVideo.addEventListener("play", updateToggle);
        heroVideo.addEventListener("pause", updateToggle);
        updateToggle();
    }

    const thumbnail = document.querySelector("#hero-video");
    const thumbnailMobile = document.querySelector("#hero-video-mobile");
    const popup = document.querySelector("#video-popup");
    const bodyOverlay = document.querySelector(".body-overlay");
    const closeBtn = popup ? popup.querySelector(".icon-close") : null;
    const htmlEl = document.documentElement; // <html> elementet
    function openPopup() {
        popup.classList.remove("hidden");
        htmlEl.classList.add("flyout-open");
        bodyOverlay.classList.add("active");
    }

    function closePopup() {
        popup.classList.add("hidden");
        htmlEl.classList.remove("flyout-open");
        bodyOverlay.classList.remove("active");
    }

    if (thumbnail && popup && bodyOverlay) {
        thumbnail.addEventListener("click", function (e) {
            e.preventDefault();
            openPopup();
        });

        if (closeBtn) {
            closeBtn.addEventListener("click", function (e) {
                e.preventDefault();
                closePopup();
            });
        }

        bodyOverlay.addEventListener("click", function (e) {
            e.preventDefault();
            closePopup();
        });
    }
    if (thumbnailMobile && popup && bodyOverlay) {
        thumbnailMobile.addEventListener("click", function (e) {
            e.preventDefault();
            openPopup();
        });

        if (closeBtn) {
            closeBtn.addEventListener("click", function (e) {
                e.preventDefault();
                closePopup();
            });
        }

        bodyOverlay.addEventListener("click", function (e) {
            e.preventDefault();
            closePopup();
        });
    }
});
//# sourceMappingURL=hero-video.js.map
